<pr-form
  (onSubmit)="submit()"
  [title]="
    entity.lastName
      ? entity.lastName + ' ' + entity.firstName
      : 'Nouvel utilisateur'
  "
  [formGroup]="form"
>
  <h3>informations</h3>

  <input formControlName="id" type="hidden" />

  <pr-input-radio
    label="Genre"
    formControlName="gender"
    [options]="[
      { value: 'M', label: 'Homme', icon: 'male' },
      { value: 'F', label: 'Femme', icon: 'female' },
    ]"
  >
  </pr-input-radio>
  <pr-input [label]="'Nom'" [derrors]="derrors"
    ><input formControlName="lastName" type="text"
  /></pr-input>
  <pr-input [label]="'Prénom'" [derrors]="derrors"
    ><input formControlName="firstName" type="text"
  /></pr-input>
  <pr-input-string-list
    formControlName="otherFirstNames"
    label="Prénom(s) d’état civil"
    placeholder="Jean"
    addLabel="Ajouter un prénom"
    [derrors]="derrors"
  ></pr-input-string-list>

  <pr-input-date
    label="Date de naissance"
    formControlName="birthDate"
    [derrors]="derrors"
  ></pr-input-date>

  <pr-input label="Nationalité" [derrors]="derrors">
    <pr-select-search
      formControlName="nationality"
      label="Nationalité"
      [options]="countries"
    >
    </pr-select-search>
  </pr-input>

  <pr-input label="Résidence fiscale" [derrors]="derrors">
    <pr-select-search
      formControlName="taxResidence"
      label="Résidence fiscale"
      [options]="countries"
    >
    </pr-select-search>
  </pr-input>

  <pr-input label="Capacité juridique" [derrors]="derrors">
    <mat-select formControlName="legalCapacity">
      @for (legalCapacity of legalCapacities; track legalCapacity) {
        <mat-option [value]="legalCapacity.id">
          {{ legalCapacity.value | translate }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input [label]="'Numéro sécu'" [derrors]="derrors"
    ><input
      formControlName="socialSecurityNumber"
      type="text"
      prSocialSecurityNumber
    />
  </pr-input>

  <h3>Naissance</h3>

  <pr-input label="Pays" [derrors]="derrors">
    <pr-select-search
      formControlName="birthCountry"
      label="Pays"
      [options]="countries"
    >
    </pr-select-search>
  </pr-input>

  <pr-input label="Departement" [derrors]="derrors">
    <pr-select-search
      formControlName="birthLocation"
      label="Departement"
      [options]="departments"
      [displayFn]="displayDepartment"
    >
    </pr-select-search>
  </pr-input>

  <pr-input label="Code postal" [derrors]="derrors">
    <input
      formControlName="birthZipCode"
      type="text"
      mask="99999"
      [showMaskTyped]="true"
    />
  </pr-input>

  <h3>Contact</h3>

  <pr-input [label]="'Adresse Email'" [derrors]="derrors"
    ><input formControlName="email" type="text" />
  </pr-input>
  <pr-input [label]="'Téléphone mobile'" [derrors]="derrors"
    ><input
      formControlName="mobile"
      type="text"
      mask="00 00 00 00 00"
      [showMaskTyped]="true"
    />
  </pr-input>
  @if (showWarningMobilePhone) {
    <div class="alert alert-danger">
      <p>
        Le numéro de téléphone mobile doit être un numéro de téléphone mobile
        français valide.
      </p>
    </div>
  }
  <pr-input [label]="'Téléphone fixe'" [derrors]="derrors"
    ><input
      formControlName="phone"
      type="text"
      mask="00 00 00 00 00"
      [showMaskTyped]="true"
    />
  </pr-input>

  <h3>Autres</h3>

  <pr-input-radio
    formControlName="usResident"
    label="Citoyen américain"
  ></pr-input-radio>
</pr-form>
